import { useTranslation } from '@frontend/i18n';
import { FormsIllustration } from '@frontend/phones#svg';
import { Heading } from '@frontend/design-system';
import { EmptyStateAnalyticsText } from '../utils/empty-state-text';

export const EmptyStateAnalyticsView = ({
  entityType,
  minAllowedDate,
  isDateValid,
}: {
  entityType: string;
  minAllowedDate: string;
  isDateValid: boolean;
}) => {
  const { t } = useTranslation('analytics-phone');
  return (
    <div css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, marginTop: 32 }}>
      <Heading level={3}>{t('Not Available')}</Heading>
      <FormsIllustration width={218} height={218} />
      <EmptyStateAnalyticsText entityType={entityType} minAllowedDate={minAllowedDate} isDateValid={isDateValid} />
    </div>
  );
};
